// extracted by mini-css-extract-plugin
export default {"Inventory":"Inventory_Inventory__YNwSO"};